import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import { Field, useForm } from 'react-final-form';
import { getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { CapsuleGroup } from '@/tools/manualCondition/CapsuleGroup';
import _ from 'lodash';

import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import type { CapsuleGroupCapsule } from '@/tools/manualCondition/manualCondition.constants';

export interface CapsuleGroupIF extends ValidatingFormComponent<CapsuleGroupCapsule[]> {
  component: 'CapsuleGroupFormComponent';
  previewId: string;
  autoUpdateDate?: boolean;
}

export const CapsuleGroupFormComponent: React.FunctionComponent<CapsuleGroupIF> = (props) => {
  const {
    name,
    testId = 'capsuleGroup',
    wrapperClassNames = '',
    label,
    validation,
    extendValidation,
    customErrorText,
    previewId,
    value,
    autoUpdateDate,
  } = props;

  const defaultValidation = () => !value || !_.isArray(value) || value.length === 0;

  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  const formState = useForm().getState();
  const showError = _.has(formState.errors, name) && formState.touched?.[name];

  return (
    <FormFieldWrapper
      testId={testId}
      label={label}
      showError={showError}
      customErrorText={customErrorText}
      wrapperClassNames={wrapperClassNames}>
      <Field name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          return <CapsuleGroup previewId={previewId} autoUpdateDate={autoUpdateDate} />;
        }}
      </Field>
    </FormFieldWrapper>
  );
};
